module.exports = __webpack_public_path__ + "static/media/eth-diamond-plain.8f65f7b1.svg";